// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wb_a bho_b bho_we"};